module.exports = __webpack_public_path__ + "static/media/slideshow-image_Three.15a93fad.png";